import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { mergeParams } from '../lib/dashboardParams';

/**
 * The dashboard's query and `setParams(patch, { push })`, which merges a
 * patch into it (lib/dashboardParams mergeParams) and replaces the history
 * entry unless asked to push.
 *
 * One call per event: setSearchParams reads the URL as it was rendered, so
 * a second call in the same event would undo the first.
 */
export default function useDashboardParams() {
  const [searchParams, setSearchParams] = useSearchParams();
  const setParams = useCallback((patch, { push = false } = {}) => {
    setSearchParams((prev) => mergeParams(prev, patch), { replace: !push });
  }, [setSearchParams]);
  return [searchParams, setParams];
}
